import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common'; 
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { Pret } from '../pret';
import { FormulaireService } from '../formulaire.service';
import { CustomValidators } from '../custom-validators';
import { BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { AppGlobal } from '../app.global';
import { environment } from '../../environments/environment';
import { DateUtils } from '../date-utils';
import { Personne } from '../personne';
import { Garantie } from '../garantie';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Information } from '../information';

@Component({
  selector: 'app-formulaire-pret',
  templateUrl: './formulaire-pret.component.html'
})

export class FormulairePretComponent implements OnInit {
  
  pretsForm = [];
  pretExpanded = [true];
  listPretsForm = [0];
  listPersonneForm =  [0];
  listQuotiteForm =  [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 95, 100];
  personneForm: FormGroup;
  infoForm: FormGroup;
  form;
  companyGroups: any;
  companies: any;
  showCaisseFiliale = [false, false, false, false];
  hideLoan = [false, false, false, false];
  typeSouscriptionList = FormulaireService.typeSouscriptionList;
  typePretList: any;
  usageBienTrList: any;
  loadingCompanyGroups = false;
  iframe: boolean;
  defaultPret: Pret;

  public collapse = false;
  maxPrets = 4;
  maxPersonnes = 2;

  apporteur: string;

  capitalRestantControl: any

  ashler: boolean;

  onlyEconomie: boolean;

  textProspect1: String;

  subTextProspect: String;

  novelia: boolean;

  residentEnabled: boolean;

  civilityList = FormulaireService.civilityList;
  professionList = FormulaireService.professionList;
  regimeSocialList = FormulaireService.regimeSocialList;
  encoursLemoineList = FormulaireService.encoursLemoineList;
  recommandationList = FormulaireService.recommandationList.sort((a,b) => a.label > b.label ? 1 : -1);
  objectifPrincipalList = FormulaireService.objectifPrincipalList;

  checkFirst: boolean;
  public submitted = false;

  @ViewChild('dateSignatureOffreDatePicker') dateSignatureOffreDatePicker: BsDatepickerDirective;

  @ViewChild('dateEffectiveDatePicker') dateEffectiveDatePicker: BsDatepickerDirective;

  @ViewChild('etablissementBancaire') etablissementBancaireView: ElementRef;
  public etablissementBancaireViewHeight;

  @ViewChild('succesModal') succesModal: ModalDirective;
  @ViewChild('errorModal') errorModal: ModalDirective;

  countriesList: any = null;

  constructor(private formulaireService: FormulaireService, private router: Router, private fb: FormBuilder,
    private appGlobal: AppGlobal, @Inject(DOCUMENT) document) {
    this.iframe = appGlobal.isIframe();
  }

  ngOnInit() {
    if (this.formulaireService.countriesList != null) 
      this.countriesList = this.formulaireService.countriesList;
    if (this.countriesList == null) this.getCountriesList();

    this.onlyEconomie = this.appGlobal.onlyEconomie();

    this.textProspect1 = this.appGlobal.getTextProspect1();
    this.subTextProspect = this.appGlobal.getSubTextProspect();

    this.capitalRestantControl = [Validators.required, CustomValidators.integer, CustomValidators.min22000];

    this.createForm(new Pret(), new Personne(), this.formulaireService.getInformation());

    this.getCompanyGroups();

    if (this.prets.controls[0].value.etablissementBancaire !== undefined) {
      this.setCompanies(this.prets.controls[0].value.etablissementBancaire, true, this.prets.controls[0], 0);
    }

    this.typePretList = FormulaireService.typePretList;

    
    if (this.prets.controls[0].value.typePret == undefined) {
      this.prets.controls[0].get('typePret').setValue('AM');
    } else {
      this.prets.controls[0].get('typePret').setValue(this.prets.controls[0].value.typePret.code);
    }

    this.checkFirst = false;
  }

  ngAfterViewInit() {
    this.changeEmptyCaisseHeight();
  }

  get usageBienList() {
    return this.getTypeSouscription().code == 'CH' ? this.appGlobal.getUsageBiens() : this.appGlobal.getUsageBiensTr();
  }

  getCompanyGroups (): void {
    this.loadingCompanyGroups = true;
    this.formulaireService.getCompanyGroups().subscribe(
      response => {
        this.companyGroups = response;
        this.loadingCompanyGroups = false; 
      },
      err => {this.companyGroups = null; this.loadingCompanyGroups = false; }
    );
  }

  setCompanies(cg: any, onInit: boolean, form, i): void {
    if (cg === null) {
        this.showCaisseFiliale[i] = false;
        return;
    }
    if (!onInit) {
      form.get('caisseFiliale').setValue(null);
    }
    this.formulaireService.getCompaniesForCompanyGroup(cg.bankId).subscribe(
      response => {
        this.companies = response;

        this.showCaisseFiliale[i] = (this.companies.length > 1);
        if (this.companies.length === 1) {
          form.get('caisseFiliale').setValue(this.companies[0]);
        }
        this.changeEmptyCaisseHeight();
      },
      err => {this.companies = null; });
  }

  handleChangeTypePret(tp: any): void {
    if (tp !== undefined && tp !== null && tp === 'PT') {
      this.prets.controls[0].get('taux').setValue('0');
    }
  }

  handleChangeTaux(t: any): void {
    const typePret = this.prets.controls[0].get('typePret').value;
    if (typePret !== undefined && typePret !== null && typePret === 'PT') {
      this.prets.controls[0].get('taux').setValue('0');
    }
  }

  createForm(pret: Pret, personne: Personne, info: Information) {
    this.form = this.fb.group({
      prets: this.fb.array([]),
      personnes: this.fb.array([]),
      recommandation: [null, [Validators.required]],
      objectifPrincipal: [null, [Validators.required]],
      email: [null, [Validators.required]],
      commentaire: [null, []],
      checkFirst: [false, []]
    });
    this.form.controls["prets"].push(this.createFormPret(pret));
    this.form.controls["personnes"].push(this.createFormPersonne(personne));
  }

  createFormPret(pret: Pret): FormGroup {
    let form = this.fb.group({
      dateEffective: [this.getTypeSouscription().code === 'CH' ? this.getInitialEffectiveDate() : null, []],
      capitalRestant: [pret.capitalRestant, this.capitalRestantControl],
      dureeRestanteMois: [pret.dureeRestanteMois, [Validators.required, CustomValidators.integer, CustomValidators.supzero]],
      dateSignatureOffre: [this.getInitialDate(), []],
      taux: [this.convertNumber(pret.taux), [Validators.required, CustomValidators.decimal]],
      typePret: [pret.typePret, [Validators.required]],
      lieuAchat: [pret.lieuAchat, []],
      usageBien: [pret.usageBien, [Validators.required]],
      etablissementBancaire: [pret.etablissementBancaire, [Validators.required]],
      caisseFiliale: [pret.caisseFiliale, [Validators.required]],
      onlyDcptia: [ true, [Validators.required]]
    });

    
    this.handleDateSignatureValidators();
    this.handleDateEffectiveValidators();
    return form;
  }

  createFormPersonne(p: Personne): FormGroup {
    let emailValidator = [Validators.required, Validators.email];
    let telValidator = ['', [Validators.required, CustomValidators.phone]];

    let defaultPays = this.formulaireService.countriesList != null ? this.formulaireService.countriesList.find(c => c != null && c.PAYS_LIB == "FRANCE METROPOLITAINE") : p.paysDeResidence;

    let form = this.fb.group({
      dateNaissance: [p.dateNaissance, [Validators.required, CustomValidators.date, CustomValidators.min18years]],
      isFumeur: [p.isFumeur, [Validators.required]],
      profession: [p.profession, [Validators.required]],
      isTravailManuel: [p.isTravailManuel, [Validators.required]],
      isTravailEnHauteur: [p.isTravailEnHauteur, [Validators.required]],
      isDeplacements: [p.isDeplacements, [Validators.required]],
      regimeSocial: [p.regimeSocial, [Validators.required]],
      paysDeResidence: [defaultPays, [Validators.required]],
      nationalite: [defaultPays, [Validators.required]],
      status: [p.status, []],
      affiliation: [p.affiliation, []],
      civility: [null, [Validators.required]],
      nom: ['', [Validators.required]],
      prenom: ['', [Validators.required]],
      telephone: telValidator,
      email: ['', emailValidator],
      adresse: ['', [Validators.required]],
      codePostal: ['', [Validators.required]],
      ville: ['', [Validators.required]],
      professionExacte: ['', [Validators.required]],
      voyage: ['', []],
      quotite: [100, []],
      encourslemoine: [p.encourslemoine, [Validators.required]]
    });

    return form;
  }

  convertNumber(value: number) {
    if (value != null && !isNaN(value)) {
      return value.toString().replace('.', ',');
    }
  }

  initGaranties(onlyDcptia): Garantie[] {
    const saveGaranties: Garantie[] = [];
    if (onlyDcptia)
      saveGaranties.push({code: "DCPTIA"});
    else {
      saveGaranties.push({code: "DCPTIA"});
      saveGaranties.push({code: "ITT"});
      saveGaranties.push({code: "IPT"});
      saveGaranties.push({code: "IPP"});
      saveGaranties.push({code: "DOS/PSY"});
    }
    return saveGaranties;
  }

  markAllFields() {
    this.prets.controls.forEach(pret => {
      Object.keys(pret['controls']).forEach(key => {
        pret.get(key).markAsDirty();
        pret.get(key).markAsTouched();
      });
    });

    this.personnes.controls.forEach(personne => {
      Object.keys(personne['controls']).forEach(key => {
        personne.get(key).markAsDirty();
        personne.get(key).markAsTouched();
      });
    });
    
  }

  
  showTelOrEmailError = false;

  onSubmit() {
    this.submitted = true;
    this.markAllFields();

    this.showTelOrEmailError = false;
    if (this.personnes.controls.length == 2) {
      if (this.personnes.controls[0].get('telephone').value === this.personnes.controls[1].get('telephone').value 
          || this.personnes.controls[0].get('email').value === this.personnes.controls[1].get('email').value) {
        this.showTelOrEmailError = true;
        return;
      }
    }

    if (this.form.valid) {
      const newPrets = this.prepareSavePrets();
      this.formulaireService.setPret(newPrets);

      const newPersonnes = this.prepareSavePersonnes();
      this.formulaireService.setPersonnes(newPersonnes);

      const newInformation = this.prepareSaveInformation(this.form.value);
      this.formulaireService.setInformation(newInformation);

      this.formulaireService.saveDevis().subscribe(
        response => {
          this.sendMail(response.internalGlobalFolderRecordId);
          this.sendMailContact();
          this.succesModal.show();
        },
        err => {
          this.sendMail("Echec projet MI");
          this.succesModal.show();
        }
      );
    } else {
    }
  }

  sendMailContact() {
    this.formulaireService.contact().subscribe(
      response => {
      },
      err => {
      }
    );
  }

  sendMail(idGlobalFolder) {
    this.formulaireService.sendProspectValorama(idGlobalFolder).subscribe(
      response => {
      },
      err => {
      }
    );
  }

  prepareSavePersonne(): Personne {
    return this.convertFormToPersonne(this.personneForm.value);
  }

  prepareSavePersonnes(): Personne[] {
    const formModelPersonnes = this.form.value.personnes;
    const savePersonnes: Personne[] = [];
    formModelPersonnes.forEach(p => {
      savePersonnes.push(this.convertFormToPersonne(p));
    });
    return savePersonnes;
  }

  convertFormToPersonne(formValue): Personne {
    const newPersonne: Personne = {
      dateNaissance: formValue.dateNaissance as string,
      isFumeur: formValue.isFumeur as boolean,
      profession: formValue.profession,
      isTravailManuel: formValue.isTravailManuel as boolean,
      isTravailEnHauteur: formValue.isTravailEnHauteur as boolean,
      isDeplacements: formValue.isDeplacements as boolean,
      regimeSocial: formValue.regimeSocial,
      paysDeResidence: formValue.paysDeResidence,
      nationalite: formValue.nationalite,
      status: formValue.status,
      affiliation: formValue.affiliation,
      quotite: formValue.quotite,
      civility: formValue.civility,
      nom: formValue.nom,
      prenom: formValue.prenom,
      telephone: formValue.telephone,
      email: formValue.email,
      adresse: formValue.adresse,
      codePostal: formValue.codePostal,
      ville: formValue.ville,
      professionExacte: formValue.professionExacte,
      voyage: formValue.voyage,
      encourslemoine: formValue.encourslemoine
    };
    return newPersonne;
  }

  prepareSaveInformation(formValue): Information {
    const newInformation: Information = {
      recommandation: formValue.recommandation as string,
      objectifPrincipal: formValue.objectifPrincipal as string,
      email: formValue.email as string,
      commentaire: formValue.commentaire as string
    };
    return newInformation;
  }

  byBankId(item1: any, item2: any) {
    return (item1 === null && item2 === null) ||
      (item1 !== null && item2 !== null && item1.bankId === item2.bankId);
  }

  byAgencyId(item1: any, item2: any) {
    return (item1 === null && item2 === null) ||
      (item1 !== null && item2 !== null && item1.agencyId === item2.agencyId);
  }

  prepareSavePrets() {
    const formModelPrets = this.form.value.prets;
    const savePrets: Pret[] = [];
    formModelPrets.forEach(p => {
      savePrets.push(this.convertFormToPret(p));
    });
    return savePrets;
  }

  convertFormToPret(formModel): Pret {
    let dd = '' + new Date().getDate();
    if (dd.length == 1) dd = '0' + dd;
    const savePret: Pret = {
      dateEffective: formModel.dateEffective as string,
      capitalRestant: formModel.capitalRestant as number,
      dureeRestanteMois: formModel.dureeRestanteMois as number,
      dateSignatureOffre: formModel.dateSignatureOffre as string,
      taux: parseFloat(formModel.taux.replace(',', '.')) as number,
      typePret: {code: formModel.typePret, label: this.getLabelCode(formModel.typePret)},
      lieuAchat: formModel.lieuAchat,
      usageBien: formModel.usageBien,
      etablissementBancaire: formModel.etablissementBancaire,
      caisseFiliale: formModel.caisseFiliale,
      garantie: formModel.onlyDcptia ? "Décès/PTIA" : "Décès/PTIA + Incap/Inval + Dos/Psy",
      garanties: this.initGaranties(formModel.onlyDcptia)
    };
    this.formulaireService.setGaranties(this.initGaranties(formModel.onlyDcptia));
    return savePret;
  }

  getLabelCode(code) {
    var label;
    this.typePretList.forEach(element => {
      
      if (element.code == code) label = element.label;
    });
    return label;
  }

  getMinDatePret() {
    if (this.getTypeSouscription().code === 'CH') {
      return new Date(2008, 0, 1);
    } else {
      const todayPlus15Days: Date = new Date();
      todayPlus15Days.setDate(todayPlus15Days.getDate() + 1);
      return todayPlus15Days;
    }
  }

  getMaxDatePret() {
    if (this.getTypeSouscription().code === 'CH') {
      const yestrday: Date = new Date();
      yestrday.setDate(yestrday.getDate() - 1);
      return yestrday;
    } else {
      const todayPlus5Years: Date = new Date();
      todayPlus5Years.setFullYear(todayPlus5Years.getFullYear() + 5);
      return todayPlus5Years;
    }
  }

  onDateSignatureOffreChange(date: Date, i) {
    const mm = date.getMonth() + 1;
    const dd = date.getDate();

    const sDate = [
      (dd > 9 ? '' : '0') + dd,
      (mm > 9 ? '' : '0') + mm,
      date.getFullYear()
    ].join('/');
    this.prets.controls[i].get('dateSignatureOffre').setValue(sDate);
    this.prets.controls[i].get('dateSignatureOffre').markAsTouched();
    this.prets.controls[i].get('dateSignatureOffre').markAsDirty();
    this.prets.controls[i].get('dateSignatureOffre').updateValueAndValidity();
  }

  onDateNaissanceChange(date: Date, i) {
    //const ctrl: FormControl = target as FormControl;
    const mm = date.getMonth() + 1;
    const dd = date.getDate();

    const sDate = [
      (dd > 9 ? '' : '0') + dd,
      (mm > 9 ? '' : '0') + mm,
      date.getFullYear()
    ].join('/');
    this.personnes.controls[i].get('dateNaissance').setValue(sDate);
    this.personnes.controls[i].get('dateNaissance').markAsDirty();
    this.personnes.controls[i].get('dateNaissance').markAsTouched();
    this.personnes.controls[i].get('dateNaissance').updateValueAndValidity();
  }

  getTypeSouscription(): any {
    return this.formulaireService.getTypeSouscription();
  }

  changeTypeSouscription(typeSouscription: any) {
    this.formulaireService.setTypeSouscription(typeSouscription);
    this.handleDateSignatureValidators();
    this.handleDateEffectiveValidators();

    this.prets.controls[0].get('dateSignatureOffre').setValue(this.getInitialDate());
    this.prets.controls[0].get('dateSignatureOffre').markAsTouched();
    this.prets.controls[0].get('dateSignatureOffre').updateValueAndValidity();
  }

  getTexts(): any {
    return this.formulaireService.getTypeSouscriptionTexts();
  }

  handleDateSignatureValidators() {
    let validators;
    if (this.getTypeSouscription().code === 'CH') {
      validators = [Validators.required, CustomValidators.date, CustomValidators.minYear2008, CustomValidators.beforeToday];
    } else {
      validators = [Validators.required, CustomValidators.date, CustomValidators.minYear2008, CustomValidators.afterToday];
    }
    this.prets.controls.forEach(pret => {
      pret.get('dateSignatureOffre').setValidators(validators);
      pret.get('dateSignatureOffre').markAsTouched();
      pret.get('dateSignatureOffre').updateValueAndValidity();
    });
  }

  handleDateEffectiveValidators() {
    let validators;
    if (this.getTypeSouscription().code === 'CH') {
      validators = [Validators.required, CustomValidators.date, CustomValidators.afterToday];
    } else {
      validators = [];
    }
    this.prets.controls.forEach(pret => {
      pret.get('dateEffective').setValue(this.getTypeSouscription().code === 'CH' ? this.getInitialEffectiveDate() : null);
      pret.get('dateEffective').setValidators(validators);
      pret.get('dateEffective').markAsTouched();
      pret.get('dateEffective').updateValueAndValidity();
    });
  }

  closeDatePicker(event, datepicker) {
    if (event.relatedTarget) {
      if (event.relatedTarget.parentNode.nodeName !== 'BS-DATEPICKER-NAVIGATION-VIEW') {
        datepicker.hide();
      }
    }
  }

  onOpenCalendar(container) {
    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };     
    container.setViewMode('month');
   }

   getInitialDate() {
    const date = new Date();
    let mm;
    let dd = 1;
    let yy = date.getFullYear();
    if (this.getTypeSouscription().code === 'TR') {
      mm = date.getMonth() + 2;
      if (mm > 12) {
        mm = 1;
        yy = yy + 1;
      }
    } else {
      mm = date.getMonth() - 1;
      if (mm < 1) {
        mm = 12;
        yy = yy - 1;
      }
    }

    const sDate = [
      (dd > 9 ? '' : '0') + dd,
      (mm > 9 ? '' : '0') + mm,
      yy
    ].join('/');
    return sDate;
  }

  changeEmptyCaisseHeight() {
    this.etablissementBancaireViewHeight = this.etablissementBancaireView.nativeElement.offsetHeight + 'px';
    
  }

  showNationalite(form: FormGroup): boolean {
    let showNationalite =  form.get('paysDeResidence').value != null && form.get('paysDeResidence').value['ALPHA3'] !== 'FRA';
    this.updateValidity('nationalite', showNationalite, form);
    if (!showNationalite) form.get('nationalite').setValue(null);
    return showNationalite;
  }

  showStatus(form: FormGroup): boolean {
    let showStatus =  form.get('paysDeResidence').value != null && form.get('paysDeResidence').value['ALPHA3'] !== 'FRA'; //&& form.get('nationalite').value != null && form.get('nationalite').value['ALPHA3'] !== 'FRA';
    this.updateValidity('status', showStatus, form);
    if (!showStatus) form.get('status').setValue(null);
    return showStatus;
  }

  showAffiliation(form: FormGroup): boolean {
    let showAffiliation = form.get('status').value != null && form.get('status').value['code'] == 'EXPATRIATE';
    this.updateValidity('affiliation', showAffiliation, form);
    if (!showAffiliation) form.get('affiliation').setValue(null);
    return showAffiliation;
  }

  updateValidity(sControl: string, check: boolean, form): void {
    let control = form.get(sControl) as FormControl;
    if (check) {
      control.setValidators([Validators.required]);
    } else {
      control.setValidators(null);
    }
    control.updateValueAndValidity();
  }

  disableRegimeSocial(rs: any, p): boolean {
    const ctrl: FormControl = p as FormControl;
    return rs !== null && rs.code !== 'INA' && ctrl !== null && ctrl.value !== null &&
      (ctrl.value.code === 'RETR' || ctrl.value.code === 'SSPR');
  }

  handleProfessionChange(p: any, target) {
    const ctrl: FormControl = target as FormControl;
    if (p !== null && (p.code === 'RETR' || p.code === 'SSPR')) {
        ctrl.setValue(this.regimeSocialList.find(e => e.code === 'INA'));
    }
  }

  hideDevisSuccesModal() {
    this.succesModal.hide();
  }

  getCountriesList (): void {
    this.formulaireService.getCountriesList().subscribe(
      response => {
        this.countriesList = response;
        this.formulaireService.countriesList = response;
        this.createForm(new Pret(), new Personne(), this.formulaireService.getInformation());
        this.personnes.controls[0].get('nationalite').markAsTouched();
        this.personnes.controls[0].get('nationalite').updateValueAndValidity();
        this.personnes.controls[0].get('paysDeResidence').markAsTouched();
        this.personnes.controls[0].get('paysDeResidence').updateValueAndValidity();
      },
      err => { }
    );
  }

  compareFn(c1: any, c2:any): boolean {     
    return c1 && c2 ? c1.code === c2.code : c1 === c2; 
  }

  getPretsControls(): FormArray {
    return <FormArray>this.form.get('prets');
  }

  

  get prets() {
    return this.form.controls["prets"] as FormArray;
  }

  get personnes() {
    return this.form.controls["personnes"] as FormArray;
  }

  addPret() {
    const form = this.createFormPret(new Pret());
    this.listPretsForm.push(this.listPretsForm.length + 1);
    this.prets.push(form);
  }

  removePret() {
    this.prets.removeAt(this.prets.length - 1);
    this.listPretsForm.pop();
  }

  

  addPersonne() {
    const form = this.createFormPersonne(new Personne());
    this.listPersonneForm.push(this.listPersonneForm.length + 1);
    this.personnes.push(form);
  }

  removePersonne() {
    this.personnes.removeAt(this.personnes.length - 1);
    this.listPersonneForm.pop();
  }

  getPersonnesControls(): FormArray {
    return <FormArray>this.form.get('personnes');
  }

  getInitialEffectiveDate() {
    const todayDate = new Date();
    const dateEffective = new Date(todayDate.getFullYear(), todayDate.getMonth(), todayDate.getDate() + 90);
    var dd = dateEffective.getDate();
    var mm = dateEffective.getMonth() + 1;
    const sDate = [ (dd > 9 ? '' : '0') + dd, (mm > 9 ? '' : '0') + mm, dateEffective.getFullYear()].join('/');
    return sDate;
  }

  onDateEffectiveChange(date: Date, target) {
    const ctrl: FormControl = target as FormControl;
    const mm = date.getMonth() + 1;
    const dd = date.getDate();

    const sDate = [
      (dd > 9 ? '' : '0') + dd,
      (mm > 9 ? '' : '0') + mm,
      date.getFullYear()
    ].join('/');
    ctrl.setValue(sDate);
  }
}



// WEBPACK FOOTER //
// ./src/app/formulaire-pret/formulaire-pret.component.ts